import { Box, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { IWorkspacePermissionsModel } from "../../../../model/PermissionModel";
import { useTranslation } from "react-i18next";

interface IPrivilegeCardListing {
  setPermissionType: (set: number) => void;
  permissionType: number;
  isItemPrivilege?: boolean;
}

function PrivilegeCardListing({
  setPermissionType,
  permissionType,
  isItemPrivilege
}: IPrivilegeCardListing) {

  const { t } = useTranslation();

  const WorkspacePermissionsModelItem: IWorkspacePermissionsModel[] = [
    {
      title: t("Privileges.Organizer"),
      content: t("Privileges.OrganizerBehavior"),
      permissionType: 3,
    },
    {
      content: t("Privileges.EditorBehavior"),
      title: t("Privileges.Editor"),
      permissionType: 1,
    },
    {
      content: t("Privileges.ReaderBehavior"),
      title: t("Privileges.Reader"),
      permissionType: 0,
    },
  ];

    const WorkspacePermissionsModelWorkspace: IWorkspacePermissionsModel[] = [
    {
      title: t("Privileges.Organizer"),
      content: t("Privileges.OrganizerBehavior"),
      permissionType: 3,
    },
    {
      content: t("Privileges.EditorBehavior"),
      title: t("Privileges.Editor"),
      permissionType: 1,
    },
    {
      content: t("Privileges.ReaderBehavior"),
      title: t("Privileges.Reader"),
      permissionType: 0,
    },
    {
      content: t("Privileges.CommonBehavior"),
      title: t("Privileges.Common"),
      permissionType: 5,
    },
  ];

  function workspaceListHandler() {
    if (isItemPrivilege) {
      return WorkspacePermissionsModelItem;
    }

    return WorkspacePermissionsModelWorkspace;
  }

  return (
    <FormControl fullWidth>
      <RadioGroup
        name="workspace-permission"
        value={permissionType}
        onChange={(e) => setPermissionType(Number(e.currentTarget.value))}
      >
        {workspaceListHandler().map(({ content, permissionType, title }) => (
          <Box
            key={permissionType}
            paddingY="10px"
            width="100%"
          >
            <Box
              display="flex"
              flexDirection="column"
              sx={{
                border: "1px solid #EAEAEA",
                borderRadius: "4px",
              }}
            >
              <FormControlLabel
                value={permissionType}
                control={<Radio />}
                label={
                  <KeyDriveBodyMin
                    color="#2d2d2d"
                    needBold
                    needEllipses={false}
                    text={title}
                  />
                }
                sx={{
                  marginLeft: "4px",
                  paddingY: "6px",
                }}
              />
              <Box paddingX="10px" paddingBottom="10px">
                <KeyDriveBodyMin
                  color="#2d2d2d"
                  needBold={false}
                  needEllipses={false}
                  text={content}
                />
              </Box>
            </Box>
          </Box>
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default PrivilegeCardListing;
